<div class="pro-widget">

    <div class="pro-widget__content">
        <div class="corr">
            <div class="corr__chart">
                <div #chart echarts [options]="chartOptions" [merge]="updateOptions" [initOpts]="initOptions"
                    (chartInit)="onChartInit($event)" class="visual"></div>
                <app-chart-info-box [information]="information()" 
                    [dialogInformationId]="dialogInformationId()"></app-chart-info-box>
            </div>
            @if(isM2Balance()){
            <div class="nmd__citation" [style.color]="colors[0] + ' !important'">
                <span> </span> {{rateDefinition?.citation + ' '}} {{attributionDate | date}}
            </div>
            }
        </div>
    </div>
</div>